import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Repeat, RepeatOneOn } from '@mui/icons-material';
import { RepeatMode } from './sonosPlayMode';
import { SONOS_BLUE, sonosIconTapSx } from './sonosUiStyles';

interface RepeatModeButtonProps {
  mode: RepeatMode;
  disabled?: boolean;
  onChange: (mode: RepeatMode) => void;
}

const RepeatModeButton: React.FC<RepeatModeButtonProps> = ({ mode, disabled, onChange }) => {
  const active = mode !== 'off';
  const Icon = mode === 'one' ? RepeatOneOn : Repeat;

  return (
    <Box sx={{ position: 'relative' }}>
      <IconButton
        disabled={disabled}
        onClick={() => onChange(mode === 'off' ? 'one' : mode === 'one' ? 'all' : 'off')}
        disableRipple
        sx={{
          color: active ? SONOS_BLUE : '#aaa',
          ...(active ? {
            bgcolor: 'rgba(35,145,255,0.12)',
            '&:active': { bgcolor: 'rgba(35,145,255,0.28)', transform: 'scale(0.93)' },
          } : sonosIconTapSx),
        }}
      >
        <Icon />
      </IconButton>
      {mode === 'one' && (
        <Box sx={{
          position: 'absolute',
          top: 4,
          right: 4,
          width: 14,
          height: 14,
          borderRadius: '50%',
          backgroundColor: SONOS_BLUE,
          color: '#fff',
          fontSize: 9,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}>
          1
        </Box>
      )}
    </Box>
  );
};

export default RepeatModeButton;
